export default __webpack_public_path__ + "e69b62fdb1a5e5fbf8463b958a3939d4.png";